import React from "react";
import {autobind} from "core-decorators";
import {inject, observer} from "mobx-react";
import {Link, RouteComponentProps} from "react-router-dom";
import {Button, Modal, Typography} from "antd";

import "./PasswordForgotten.scss";
import {paths} from "@/routes";
import logo from "@/assets/logo.svg";
import ResetPasswordForm from "./ResetPasswordForm";
import UpdatePasswordForm from "./UpdatePasswordForm";
import Store from "@/stores";

// https://www.pluralsight.com/guides/react-router-typescript
export interface IPasswordForgottenProps extends RouteComponentProps {
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class PasswordForgotten extends React.Component<IPasswordForgottenProps, any> {
  async onSubmitResetPasswordForm({email}: {email: string}) {
    const {session} = this.props.store!;
    try {
      const response = await session.resetPassword(email);
      Modal.success({
        content:
          response.message ||
          "You will receive an email with instructions for how to confirm your email address in a few minutes.",
      });
    } catch (error) {
      console.error(error);
      Modal.error({content: error?.data?.errors?.[0] || "Oops! Something went wrong"});
      throw error; // this is caught in the form
    }
  }

  async onSubmitUpdatePasswordForm({password}: {password: string}) {
    const {history, session} = this.props.store!;
    try {
      await session.updatePassword(password);
      Modal.success({
        content: "Your password has been changed successfully. You are now signed in.",
        onOk() {
          history.history.push(paths.home());
        },
      });
    } catch (error) {
      console.error(error);
      Modal.error({content: error?.data?.errors?.full_messages?.[0] || "Oops! Something went wrong"});
      throw error; // this is caught in the form
    }
  }

  public render() {
    const {session} = this.props.store!;
    return (
      <div className="PasswordForgotten">
        <img className="Logo" src={logo} alt="Logo" />
        {session.isSignedIn ? (
          <UpdatePasswordForm onSubmit={this.onSubmitUpdatePasswordForm} />
        ) : (
          <>
            <ResetPasswordForm onSubmit={this.onSubmitResetPasswordForm} />
            <Typography.Paragraph style={{marginBottom: 5}}>Already have an account?</Typography.Paragraph>
            <Link to={paths.signIn()}>
              <Button type="default">Sign in</Button>
            </Link>
          </>
        )}
      </div>
    );
  }
}
